// @flow

import type { PendingIncomingPayment } from './types';

export function getSafeBoletoUrl(incomingPayment: PendingIncomingPayment): string {
  const boletoUrl = incomingPayment['boleto_url'];
  if(!boletoUrl){
    throw new Error('Boleto: no barcode in incoming payment');
  }
  return boletoUrl;
}
